export default {
  notification: {
    success: {
      disableSharing: 'El compartición del dashboard fue deshabilitado con éxito.',
    },
  },
  label: {
    title: {
      addChart: 'Agregar componente',
    },
    button: {
      addChart: 'Agregar',
    },
    chartPerPage: 'Total por página',
    searchCard: 'Buscar componente',
  },
  dataType: {
    listening: 'Datos no propietarios',
    sac: 'Datos propietarios',
    page: 'Métricas de páginas',
    blip: 'BLIP',
    'sac-listening': 'Propietarios + No propietarios',
    custom: 'Personalizados',
    static: 'Complementarios',
    'sac-status': 'Smart Care',
    mp: 'MP',
    sc: 'SC',
    contacts: 'Contactos',
    messages: 'Mensajes',
    'active-messages': 'Mensajes activos',
    'event-track': 'Registro de eventos',
    'human-service': 'Atención humana',
  },
};
